import React, { FC } from "react";
import { Box, Theme, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { NavLink } from "react-router-dom";
import { RoleAction } from "../../../enums/permission-actions";
import useUserPermissions from "../../../hooks/user-permissions";

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    flexGrow: 1,
  },
  navButton: {
    variant: "contained",
    color: "primary",
  },
  navTab: {
    position: "relative",
    color: "white",
    textDecoration: "none",
  },
  activeTab: {
    fontWeight: "bold",
    borderBottom: "2px solid " + theme.palette.secondary.main,
  },
  menuTab: {
    position: "relative",
    color: "black",
    textDecoration: "none",
  },
  activeMenuTab: {
    fontWeight: "bold",
    color: "black",
    borderBottom: "2px solid " + theme.palette.secondary.main,
  },
  titleTab: {
    position: "relative",
    color: "white",
    textDecoration: "none",
    fontWeight: "bold",
  },
  preProdWarning: {
    color: theme.palette.error.main,
  },
}));

const NavButtons: FC = () => {
  const classes = useStyles();

  const [isViewRecordsMgmtDisabled] = useUserPermissions(RoleAction.VIEW_RECORDS_MGMT);
  const [isViewMajorEventsDisabled] = useUserPermissions(RoleAction.VIEW_MAJOR_EVENTS);

  return (
    <>
      <Box m={1} pt={0.5} className={classes.title}>
        <Button className={classes.navButton}>
          <NavLink
            className={({ isActive }) => {
              return `${classes.navTab}${isActive ? " " + classes.activeTab : ""}`;
            }}
            to={"/feed"}
          >
            Feed
          </NavLink>
        </Button>
        {!isViewRecordsMgmtDisabled && (
          <Button className={classes.navButton}>
            <NavLink
              className={({ isActive }) => {
                return `${classes.navTab}${isActive ? " " + classes.activeTab : ""}`;
              }}
              to={"/records-management"}
            >
              Records Management
            </NavLink>
          </Button>
        )}
        {!isViewMajorEventsDisabled && (
          <Button className={classes.navButton}>
            <NavLink
              className={({ isActive }) => {
                return `${classes.navTab}${isActive ? " " + classes.activeTab : ""}`;
              }}
              to={"/event-management"}
            >
              Construction & Events
            </NavLink>
          </Button>
        )}
        <Button className={classes.navButton}>
          <NavLink
            className={({ isActive }) => {
              return `${classes.navTab}${isActive ? " " + classes.activeTab : ""}`;
            }}
            to={"/dashboard"}
          >
            Dashboard
          </NavLink>
        </Button>
      </Box>
    </>
  );
};

export default NavButtons;
